import { imageIdOf, type PlacedEntity, type StoryCtx } from '@dispositio/core';
import type { VNode } from './canvasModel';

export const GROUP_MIN = { w: 140, h: 100 };
export const GROUP_DEFAULT = { w: 360, h: 240 };

// Lage der Karten, Kategorien (Rahmen) und ihr Raster stehen in core (gemeinsam mit dem Server, z. B. für das Tutorial und den Import)
export {
  CATEGORY_COLORS,
  LIB_CELL,
  SLOT,
  categoryOf,
  frameSize,
  groupsOfType,
  growthShift,
  inGroup,
  layoutLibrary,
  libraryEntities,
  membersOf,
  newCategoryFrame,
  slotInGroup,
  type PlacedEntity,
} from '@dispositio/core';

/** Der Eintrag als Element der Zeichenfläche (Karte wie die Karten der Planung). */
export function entityVNode(ctx: StoryCtx, p: PlacedEntity): VNode {
  const type = ctx.types.get(p.entity.typeId)!;
  const f = p.entity.fields;
  const title = String(f[type.titleKey] ?? '').trim();
  const hover = type.hoverKey ? String(f[type.hoverKey] ?? '').trim() : '';
  return {
    id: `entity:${p.entity.id}`,
    role: 'card',
    nodeId: p.entity.id,
    x: p.x,
    y: p.y,
    w: 0,
    h: 0,
    title: title || type.name,
    hover,
    when: '',
    typeName: type.name,
    typeColor: type.color,
    tagColor: null,
    chapterColor: null,
    imageId: imageIdOf(type, f, p.entity.colorSlot, p.entity.id),
    refKey: p.entity.refKey,
    empty: false,
    kids: [],
    enterable: false,
    drag: 'free',
  };
}
